"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationBackground = exports.NotificationType = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const close_svg_1 = __importDefault(require("../../icons/close.svg"));
const ButtonIcon_1 = __importStar(require("../ButtonIcon"));
const notificationSuccess_svg_1 = __importDefault(require("../../icons/notificationSuccess.svg"));
const notification_svg_1 = __importDefault(require("../../icons/notification.svg"));
const notFiled_svg_1 = __importDefault(require("../../icons/notFiled.svg"));
const index_module_css_1 = __importDefault(require("./index.module.css"));
var NotificationType;
(function (NotificationType) {
    NotificationType["Error"] = "Error";
    NotificationType["Warning"] = "Warning";
    NotificationType["Info"] = "Info";
    NotificationType["Success"] = "Success";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var NotificationBackground;
(function (NotificationBackground) {
    NotificationBackground["Dark"] = "Dark";
    NotificationBackground["Light"] = "Light";
})(NotificationBackground || (exports.NotificationBackground = NotificationBackground = {}));
const iconsByType = {
    [NotificationType.Error]: notFiled_svg_1.default,
    [NotificationType.Warning]: notification_svg_1.default,
    [NotificationType.Info]: notification_svg_1.default,
    [NotificationType.Success]: notificationSuccess_svg_1.default,
};
const Notification = ({ id, title, type = NotificationType.Info, onClose, background = NotificationBackground.Dark, }) => {
    const Icon = iconsByType[type];
    const handleClose = (0, react_1.useCallback)(() => {
        if (onClose) {
            onClose(id);
        }
    }, [id, onClose]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)(index_module_css_1.default.notification, index_module_css_1.default[`notification${background}`]), role: "alert", children: [(0, jsx_runtime_1.jsxs)("div", { className: index_module_css_1.default.content, children: [Icon && ((0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)(index_module_css_1.default.icon, index_module_css_1.default[`icon${type}`]), children: (0, jsx_runtime_1.jsx)(Icon, { color: "white", "data-icon-id": `Notification${type}` }) })), (0, jsx_runtime_1.jsx)("div", { className: index_module_css_1.default.text, children: title })] }), onClose && ((0, jsx_runtime_1.jsx)(ButtonIcon_1.default, { style: ButtonIcon_1.ButtonIconStyle.SmallClose, "aria-label": "Close", onClick: handleClose, children: (0, jsx_runtime_1.jsx)(close_svg_1.default, { size: 10 }) }))] }));
};
exports.default = Notification;
